import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { MasterComponent } from './master/master.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppInsightsService } from './services/app-insights.service';
import { TempDataService } from './Shared/tempData.service';
import { ToastrModule } from 'ngx-toastr';
import { ErrorPageComponent } from './Shared/ErrorPage/ErrorPage.component';
// Modified by Karanam on Oct 09 2026 to fix code review comment F-01: component renamed; import commented out below.
// import { PersonalApiKeyPlaceholderComponent } from './Shared/personal-api-key-placeholder/personal-api-key-placeholder.component';
import { PersonalApiKeyComponent } from './Shared/personal-api-key/personal-api-key.component';
// Modified by Karanam on Oct 09 2026 to fix code review comment F-01: FAQ page component (spec 6.3).
import { PersonalApiKeyFaqComponent } from './Shared/personal-api-key-faq/personal-api-key-faq.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CustomPreloadingStrategy } from './Shared/custom-preloading';
import { SharedModule } from './Shared/shared.module';
import {ServiceWorkerModule} from '@angular/service-worker';
import {VersionService} from './services/version.service';
import { CrcInterceptor } from './crc.interceptor';
import {FacOpsDataService} from './services/operations/facOpsDataService.service';
import { MsalGuard, MsalBroadcastService, MsalService, MsalModule, MsalInterceptor } from '@azure/msal-angular';
 import { AzureMapsModule } from 'ng-azure-maps'
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as atlas from 'azure-maps-control';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { CommonMethodService } from './Shared/common-method.service';
import { customCurrencyPipe } from './Shared/customCurrency.pipe';
// Logger callback for MSAL
export function loggerCallback(logLevel, message, piiEnabled) {
  // console.log(message);
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({ declarations: [
        AppComponent,
        MasterComponent,
        ErrorPageComponent,
        // Modified by Karanam on Oct 09 2026 to fix code review comment F-01: declaration renamed.
        // PersonalApiKeyPlaceholderComponent,
        PersonalApiKeyComponent,
        // Modified by Karanam on Oct 09 2026 to fix code review comment F-01: declare the FAQ page.
        PersonalApiKeyFaqComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        PaginationModule,
        FormsModule,
        ReactiveFormsModule,
        MsalModule,
        ToastrModule.forRoot({ preventDuplicates: true }),
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
        ModalModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
        SharedModule,
        AzureMapsModule.forRoot({
              authOptions: {
                authType: atlas.AuthenticationType.subscriptionKey,
                subscriptionKey: 'PLBg9m-FRGdbQcCsUCpauDnU3K4GtXxWU7jdvynpqUU'
              }
            })], providers: [
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CrcInterceptor,
            multi: true,
        },
        CommonMethodService,
        CurrencyPipe,
        customCurrencyPipe,
        DecimalPipe,
        AppInsightsService,
        TempDataService,
        VersionService,
        CustomPreloadingStrategy,
        FacOpsDataService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
